// todo: this form should not exist, it should rather reuse the FeeForm.js component
import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Formik, Field, Form } from 'formik'
import yup from 'yup'
import get from 'lodash/get'
import find from 'lodash/find'
import BigNumber from 'bignumber.js'

import axios, { capi } from '@atheneum/api'

import { precision } from '@atheneum/api/dist/lib'

import AccountingAdjustmentsPreview from './AccountingAdjustmentsPreview'
import Button from '@components/Button'
import FormError from '@components/FormError'
import FormLoader from '@components/FormLoader'
import DatePicker from '@components/Form/DatePicker'
import { Dropdown } from '@components/Form/Autocomplete'
import Input from '@components/Form/Input'
import InfoBox from '@components/InfoBox'
import { validateProject } from '../helpers/fee.helpers.js'

import FeeFormStore from '../FeeForm/feeForm.store'

class BackdatingFeeForm extends Component {
  static propTypes = {
    staticData: PropTypes.object,
    feeStore: PropTypes.object,
    modalStore: PropTypes.object,
    growlStore: PropTypes.object,
    fee: PropTypes.object,
    project: PropTypes.object
  }

  static defaultProps = {
    epl: true,
    hideButtons: true,
    showCloseIcon: true,
    shouldCloseOnOverlayClick: true
  }

  state = {
    error: null,
    contract: null
  }

  constructor(props) {
    super(props)
    this.feeFormStore = new FeeFormStore(
      props.staticData,
      props.fee,
      props.project
    )
  }

  componentDidMount = () => {
    this.setState({
      contract: this.props.fee.contract
    })
  }

  calcFeeTypeId(eplStatusId) {
    const { staticData, fee } = this.props
    const { CONST } = staticData
    const currentValue = fee.feeTypeId

    if (currentValue) return currentValue

    return eplStatusId === CONST.EPL_STATUSES.NOT_INTERVIEWED
      ? CONST.FEE_TYPES.CANCELLATION_RESCHEDULING
      : CONST.FEE_TYPES.BASE_FEE
  }

  getInitialFormValues() {
    const { fee } = this.props
    return {
      feeTypeId: this.calcFeeTypeId(fee.eplStatusId),
      deliveryDate: moment(fee.deliveryDate).format('YYYY-MM-DD'),
      value: fee.feeValue,
      currencyId: fee.feeCurrencyId,
      credits: fee.credits,
      contractId: Number(get(fee, 'contractId', null))
    }
  }

  getTitle(fee) {
    return `Edit fee (backdating in effect)`
  }

  getContractOptions() {
    const { applicableContracts } = this.feeFormStore
    const contracts = [...applicableContracts]

    const contract = get(this.props.fee, 'contract')

    if (contract) {
      const hasContract = find(contracts, { id: contract.id })
      if (!hasContract) {
        contracts.unshift(contract)
      }
    }

    return [{ id: 0, label: 'No contract' }, ...contracts]
  }

  onContractChange = (form, contract) => {
    const { staticData } = this.props

    const { CONTRACT_TYPES } = staticData.CONST

    if (contract.id === Number(form.values.contractId)) return

    form.setFieldValue('contractId', contract.id, false)
    form.setFieldTouched('contractId', true)

    if (contract.id === 0) {
      form.setFieldValue('credits', 0, false)
      form.setFieldTouched('credits', true)
      form.setFieldValue('value', 0, false)
      form.setFieldTouched('value', true)
    } else if (contract.contractTypeId === CONTRACT_TYPES.PAYG) {
      form.setFieldValue('credits', 0, false)
      form.setFieldTouched('credits', true)
    } else {
      form.setFieldValue('value', 0, false)
      form.setFieldTouched('value', true)
      form.setFieldValue('currencyId', contract.currencyId, false)
      form.setFieldTouched('currencyId', true)
    }

    this.setState({ contract })
  }

  onCreditsChange = (form, newCreditValue) => {
    const credits = Number(newCreditValue)

    form.setFieldValue('credits', newCreditValue, false)
    form.setFieldTouched('credits', true)

    const creditValue = this.state.contract
      ? this.state.contract.creditValue
      : 0

    const value = Number.isNaN(credits)
      ? 0
      : parseFloat(Number(credits * creditValue).toFixed(2))

    form.setFieldValue('value', value, false)
  }

  onValueChange = (form, newFeeValue) => {
    const value = Number(newFeeValue)

    form.setFieldValue('value', newFeeValue, false)
    form.setFieldTouched('value', true)

    if (this.isNonPaygContractSelected(form.values.contractId)) {
      const creditValue = this.state.contract
        ? this.state.contract.creditValue
        : 0

      const credits = Number.isNaN(value)
        ? 0
        : BigNumber(value).div(creditValue).decimalPlaces(6).toNumber()

      form.setFieldValue('credits', credits, false)
    }
  }

  getContractTypeId = () => {
    const { fee } = this.props

    if (this.state.contract) return this.state.contract.contractTypeId
    if (fee.contract) return fee.contract.contractTypeId

    return null
  }

  isNonPaygContractSelected = contractId => {
    if (!contractId) return false
    const isNoContractSelected = parseInt(contractId, 10) === 0
    if (isNoContractSelected) return false

    const { CONTRACT_TYPES } = this.props.staticData.CONST
    const isNonPaygContractSelected =
      this.getContractTypeId() !== CONTRACT_TYPES.PAYG

    return isNonPaygContractSelected
  }

  handleCreateInvoice = async (fee, project, isCallOnly = false) => {
    const { growlStore } = this.props
    growlStore.showSuccess('Creating or updating invoice ...')
    try {
      await capi.createInvoice({
        fee: {
          id: fee.id,
          invoiceId: fee.invoiceId,
          project: {
            id: fee.project.id,
            capiProjectType: fee.project.capiProjectType,
            invoicingEntityId: fee.project.invoicingEntityId,
            caseCode: fee.project.caseCode,
            invoicingRegionId: project.office.address.country.invoicingRegionId
          },
          feeItems: fee.feeItems.map(feeItem => ({
            feeTypeId: feeItem.feeTypeId,
            currencyId: feeItem.currencyId,
          })
          )
        },
        callOnlyInvoice: isCallOnly ? '1' : '0'
      })
      growlStore.showSuccess('Successfully created invoice...')
    } catch (error) {
      growlStore.showError(`Error creating fee and invoice: ${JSON.stringify(error)}`)
    }
  }

  handleCAPIInvoiceCreate = async (fee) => {
    const { growlStore, project } = this.props
    try {
      const call = (await axios({
        method: 'get',
        url: `${process.env.REACT_APP_CAPI_SERVICE_URL}/calls/check?eplId=${fee.expertProjectLinkId}`,
      })).data

      let isCAPIProject = false
      try {
        const capiResponse = (await axios({
          method: 'get',
          url: `${process.env.REACT_APP_CAPI_SERVICE_URL}/check?p=${project.id}`,
        })).data

        isCAPIProject = !!capiResponse.project
      } catch (error) {
        console.error(error)
      }

      if (isCAPIProject && (project.invoicingEntityId || project.capiProjectType)) {
        if (call && call.mck_call_id && call.status === 'completed') {
          await this.handleCreateInvoice(fee, project, true)
          return
        }

        const MC_KINSEY_PARENT_ACCOUNT_ID = 32
        if (isCAPIProject && project.parentAccountId === MC_KINSEY_PARENT_ACCOUNT_ID) {
          await this.handleCreateInvoice(fee, project, false)
        }
      }

    } catch (error) {
      growlStore.showError(error)
    }
  }

  handleFormSubmission = async (values, actions) => {
    this.setState({ error: null })

    const { fee, feeStore, deliverableStore, project, modalStore, growlStore } = this.props
    const feeData = values

    const {
      isProjectInHardcodedList,
      isProjectAfterCutOffDate,
      isValid,
      errMsg
    } = await validateProject(project, feeData);

    if(!isValid) {
      modalStore.close()
      growlStore.showError(errMsg);
      return
    }

    return this.feeFormStore
      .saveFeeInBackdating(fee.id, feeData)
      .then(async savedFee => {
        if (!isProjectInHardcodedList && isProjectAfterCutOffDate) {
          await this.handleCAPIInvoiceCreate(savedFee)
        }
        modalStore.close()
        growlStore.showSuccess('Fee updated successfully.')

        if (fee.projectId) {
          deliverableStore.get(fee.projectId)
        }

        if (fee.id) {
          feeStore.get(fee.id)
        }
      })
      .catch(err => {
        this.props.growlStore.showError(err)
        this.setState({ error: err.message })
        actions.setSubmitting(false)
      })
  }

  renderOptionValue = option => {
    const { contractCoverages } = this.props.staticData.names
    const coverage = contractCoverages[option.contractCoverageId]

    return option.id ? (
      <span>
        {option.contractReference} ({coverage})
      </span>
    ) : (
        option.label
      )
  }

  renderAssociatedInvoiceWarning = fee => {
    if (!fee.invoiceId) return null

    return (
      <div className="m-b-lg">
        <div className="hr-separator" />
        <InfoBox theme="red">
          The fee has been associated with the invoice, hence cannot be edited
          anymore. Please consult with finance department about further action.
        </InfoBox>
      </div>
    )
  }

  render() {
    const { fee, staticData, modalStore } = this.props
    const { FEE_TYPES } = staticData.CONST
    const currentContractTypeId = this.getContractTypeId()

    return (
      <div className="expert-form" data-cy="backdating-modal">
        {this.renderAssociatedInvoiceWarning(fee)}
        <Formik
          initialValues={this.getInitialFormValues()}
          validationSchema={getValidationSchema(
            staticData,
            currentContractTypeId
          )}
          onSubmit={this.handleFormSubmission}
          render={form => (
            <Form onSubmit={form.handleSubmit}>
              <FormLoader loading={form.isSubmitting} />
              <h1 className="expert-form__title">{this.getTitle(fee)}</h1>
              <FormError error={this.state.error} />
              <Field
                name="contractId"
                placeholder="Select contract"
                label="Contract"
                options={this.getContractOptions()}
                itemToString={this.renderOptionValue}
                onChange={contract => this.onContractChange(form, contract)}
                component={Dropdown}
              />

              <Field
                short
                name="deliveryDate"
                label="Delivery date"
                dateOnly
                maxDate={moment().format('YYYY-MM-DD')}
                component={DatePicker}
              />

              <div className="expert-form__input-group">
                <label className="expert-form__label">Fee value</label>
                <div className="expert-form__input-wrapper expert-form__input-wrapper__inline-children">
                  <Field
                    noLabel
                    extraShort
                    name="currencyId"
                    placeholder="Select currency"
                    options={staticData.currencies}
                    itemToString={item => item && item.name}
                    disabled={this.isNonPaygContractSelected(
                      form.values.contractId
                    )}
                    component={Dropdown}
                  />
                  <Field
                    name="value"
                    placeholder="Amount"
                    extraShort
                    onChange={e => this.onValueChange(form, e.target.value)}
                    component={Input}
                  />
                  <div />
                </div>
              </div>
              <Field
                name="credits"
                placeholder="Credits"
                label="Credits"
                extraShort
                onChange={e => this.onCreditsChange(form, e.target.value)}
                disabled={
                  !this.isNonPaygContractSelected(form.values.contractId)
                }
                component={Input}
              />
              <Field
                name="feeTypeId"
                placeholder="Select fee type"
                label="Fee type"
                itemToString={item => item && item.name}
                options={staticData.feeTypes.filter(
                  f =>
                    form.values.feeTypeId === f.id || f.id !== FEE_TYPES.OTHER
                )}
                component={Dropdown}
              />
              <AccountingAdjustmentsPreview
                originalFeeValues={this.getInitialFormValues()}
                newFeeValues={form.values}
                contractOptions={this.getContractOptions()}
              />

              <div className="expert-form__section m-t-lg">
                <Button
                  primary
                  submit
                  disabled={form.isSubmitting || fee.invoiceId}>
                  Save
                </Button>
                <Button onClick={modalStore.close} disabled={form.isSubmitting}>
                  Cancel
                </Button>
              </div>
            </Form>
          )}
        />
      </div>
    )
  }
}

function getValidationSchema(staticData, contractTypeId) {
  const { CONTRACT_TYPES } = staticData.CONST

  let currencySchema
  if (!contractTypeId || contractTypeId === CONTRACT_TYPES.PAYG) {
    currencySchema = yup.number().integer().required()
  } else {
    currencySchema = yup.number().integer().nullable()
  }

  let valueSchema

  if (!contractTypeId || contractTypeId === CONTRACT_TYPES.PAYG) {
    valueSchema = yup
      .number()
      .test(
        'two-decimal-places',
        'Number can contain only 2 decimal places. (e.g. 33.20)',
        precision(2)
      )
      .nullable()
      .required('Fee value is required for PAYG contracts')
  } else {
    valueSchema = yup.number().nullable()
  }

  let creditSchema
  if (contractTypeId && contractTypeId !== CONTRACT_TYPES.PAYG) {
    creditSchema = yup
      .number()
      .test(
        'six-decimal-places',
        'Credits can contain up to 6 decimal places. (e.g. 0.123456)',
        precision(6)
      )
      .nullable()
      .required('Credits are required for PAC and SUB contracts')
  } else {
    creditSchema = yup.number().nullable()
  }

  const validationSchema = {
    currencyId: currencySchema,
    value: valueSchema,
    credits: creditSchema,
    contractId: yup
      .number()
      .integer()
      .nullable()
      .required('Contract is required'),
    deliveryDate: yup.date().nullable().required('Delivery date is required'),
    feeTypeId: yup
      .number()
      .integer()
      .nullable()
      .required('Fee type is required')
  }

  return yup.object().shape(validationSchema)
}

export default withRouter(
  inject(
    'staticData',
    'modalStore',
    'growlStore',
    'deliverableStore'
  )(observer(BackdatingFeeForm))
)
